import { type FirebaseOptions, getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import firebaseCompat from 'firebase/compat/app';
import 'firebase/compat/auth';
import { getFirestore } from 'firebase/firestore';

function getFirebaseClientConfig(): FirebaseOptions {
  const config: FirebaseOptions = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };

  if (!config.apiKey || !config.authDomain || !config.projectId || !config.appId) {
    throw new Error(
      'Firebase client configuration is incomplete. Set VITE_FIREBASE_API_KEY, VITE_FIREBASE_AUTH_DOMAIN, VITE_FIREBASE_PROJECT_ID, and VITE_FIREBASE_APP_ID.'
    );
  }

  const measurementId = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;
  if (measurementId) {
    config.measurementId = measurementId;
  }

  return config;
}

const firebaseConfig = getFirebaseClientConfig();

const firebaseApp = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

if (!firebaseCompat.apps.length) {
  firebaseCompat.initializeApp(firebaseConfig);
}
const firebaseCompatApp = firebaseCompat.app();

const firebaseAuth = getAuth(firebaseApp);
firebaseAuth.useDeviceLanguage();

const firebaseCompatAuth = firebaseCompatApp.auth();

// Connect to the named Firestore database 'decoa-langfuse'
const firebaseFirestore = getFirestore(firebaseApp, 'decoa-langfuse');

export { firebaseApp, firebaseAuth, firebaseCompatAuth, firebaseFirestore };
